import { get } from 'axios'

export const getParticipationByGroup = groupId => {
  return get(`users/summary/${groupId || 'company'}`).then(res => {
    if (!res.data) return {}

    return res.data
  })
}

export default {
  getParticipationByGroup,
}
